// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._49tABAG-{display:flex;flex-direction:column;gap:max(1.13rem,min(1.25vw,1.5rem))}.aZ26bt9t{font-size:max(1.13rem,min(1.25vw,1.5rem));font-weight:600;font-weight:500;text-align:center}.IS\\+kvojS{font-size:max(.75rem,min(.73vw,.88rem))}.E0DX6LrH{display:grid;grid-template-columns:repeat(2,1fr);grid-gap:max(.75rem,min(.83vw,1rem));gap:max(.75rem,min(.83vw,1rem))}@media(max-width:1023.98px){.E0DX6LrH{display:flex;flex-direction:column}}.XfLPEklx{width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"container": "_49tABAG-",
	"title": "aZ26bt9t",
	"text": "IS+kvojS",
	"control": "E0DX6LrH",
	"controlBtn": "XfLPEklx"
};
module.exports = ___CSS_LOADER_EXPORT___;
